

$(document).ready(function(){


    if($(".landing-story-slider").length){

        $('.landing-story-slider').slick({
            arrows: true,
            dots: true,
            autoplay: false,
            autoplaySpeed: 1000,
            speed: 1000,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [{
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        dots: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.5,
                        dots: true,
                        arrows: false,
                        infinite: false,
                    }
                },
                {
                    breakpoint: 360,
                    settings: {
                        slidesToShow: 1,
                        dots: true,
                        arrows: false,
                    }
                }
            ]
        });

    }


    if($(".new_landing_sidebar").length) {
        $('.new_landing_sidebar').slick({
            arrows: false,
            dots: true,
            autoplay: false,
            autoplaySpeed: 1000,
            speed: 1000,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
        });
    }


    $(".landing-story .teams_cstm_btn").on("click", function(e){
        e.preventDefault();
        var scrollTo = $(document).height() - ($(window).height() * 1.2);
        if(window.matchMedia('(max-width: 991px)').matches) {
            scrollTo = $(document).height() - ($(window).height() * 2.5);
        }
        $("html, body").animate({ scrollTop: scrollTo }, 1000);
    });

});